import { render, staticRenderFns } from "./SubMenuList.vue?vue&type=template&id=22ddb418&"
import script from "./SubMenuList.vue?vue&type=script&lang=js&"
export * from "./SubMenuList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports